export default __webpack_public_path__ + "static/media/rosey.a877c983.png";